export const orderInquiryAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }